import { useState } from 'react';
import { faqs } from '@/mocks/site';

export default function HomeFaq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-[1440px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="font-label text-xs tracking-[0.3em] text-secondary-600">常见问题 / FAQ</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            你可能想问的两三件事
          </h2>
          <p className="mt-5 font-body text-sm leading-relaxed text-foreground-600">
            还有别的问题，可以到联系页面直接提交，我们会在工作日回复。
          </p>
        </div>

        <div className="lg:col-span-8">
          <ul className="divide-y divide-background-200 border-y border-background-200">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <li key={item.q}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 py-5 text-left"
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                        {item.q}
                      </span>
                      <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full border border-background-300 text-foreground-700">
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <p className="pb-6 pr-10 font-body text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}